import { Button } from "antd";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { useParams } from "react-router-dom";
import { get_leaderboardScore } from "../../../services/submission";
import {
  getDashboardPerformance,
  getExportTaskSubmission,
} from "../../../services/task";
import dayjs from "dayjs";

const ExportExcel = ({ dataExport, dataExportTask }) => {
  const params = useParams();

  const exportExcel = async () => {
    console.log("dataExportTask", dataExportTask);
    const main_metric = JSON.parse(dataExportTask[0].metrics).filter((item) => {
      if (item.default == true) {
        return item;
      }
    });
    console.log("exportExcel", main_metric);
    // =========rest api==========
    const res_performance = await getDashboardPerformance({
      task_id: params.task_id ? params.task_id : params.id,
      name: main_metric[0].name,
      // name: "score",
      // order: "desc",
      order: main_metric[0].order,
    });

    const res = await getExportTaskSubmission({
      task_id: params.task_id ? params.task_id : params.id,
    });

    const Detail = dataExportTask.map((item) => {
      return {
        task_name: item.name,
        detail: item.information,
        tags: item.tags,
        task_type: item.type == 1 ? "event" : "general",
        sub_type: item.type == 1 ? "model" : "result",
        start_time: item.start_date != null ? item.start_date : "",
        end_time: item.end_date != null ? item.end_date : "",
      };
    });

    console.log("res_performance data export::", res_performance.data);

    const workbook = new ExcelJS.Workbook();
    // =============sheet detail================
    const detailsheet = workbook.addWorksheet("Detail");

    detailsheet.getCell("A1").value = "รายการ";
    detailsheet.getCell("B1").value = "รายละเอียด";
    detailsheet.getCell("A2").value = "Task Name";
    detailsheet.getCell("A3").value = "Task Detail";
    detailsheet.getCell("A4").value = "Tags";
    detailsheet.getCell("A5").value = "Task Type";
    detailsheet.getCell("A6").value = "Submission Type";
    detailsheet.getCell("A7").value = "Start Time";
    detailsheet.getCell("A8").value = "End Time";

    detailsheet.getCell("A10").value = "รายการ";
    detailsheet.getCell("B10").value = "สถิติ";
    detailsheet.getCell("A11").value = "จำนวนผู้ใช้งานที่ลงทะเบียนกิจกรรม";
    detailsheet.getCell("A12").value = "จำนวนผู้ใช้งานที่ส่งโมเดลเข้าร่วมทดสอบ";
    detailsheet.getCell("A13").value = "จำนวน Submit ทั้งหมด";
    detailsheet.getCell("A14").value = "จำนวน Submit สูงสุดต่อคน";
    detailsheet.getCell("A15").value = "จำนวน Submit เฉลี่ยต่อคน";
    detailsheet.getCell("A16").value = "จำนวน Submit สูงสุดต่อทีม";
    detailsheet.getCell("A17").value = "จำนวนดาวน์โหลด Dataset";

    // ตั้งค่า background color และจัดตำแหน่งข้อความสำหรับเซลล์หัวคอลัมน์
    const detailHeader = ["A1", "B1", "A10", "B10"];
    detailHeader.forEach((cell) => {
      detailsheet.getCell(cell).alignment = {
        horizontal: "center",
        vertical: "middle",
      };
      detailsheet.getCell(cell).font = { bold: true };
      detailsheet.getCell(cell).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "DAE9F8" }, // สีเหลืองทอง
      };
    });

    const widthColumnsDetail = [{ width: 20 }, { width: 100 }];
    detailsheet.columns = widthColumnsDetail;

    // value=======================
    // ====sec1=======
    detailsheet.getCell("B2").value = Detail[0]?.task_name;
    detailsheet.getCell("B3").value = Detail[0]?.detail;
    detailsheet.getCell("B4").value = Detail[0]?.tags;
    detailsheet.getCell("B5").value = Detail[0]?.task_type;
    detailsheet.getCell("B6").value = Detail[0]?.sub_type;
    detailsheet.getCell("B7").value = dayjs(Detail[0]?.start_time).format(
      "DD-MM-YYYY HH:mm:ss",
    );
    detailsheet.getCell("B8").value = dayjs(Detail[0]?.end_time).format(
      "DD-MM-YYYY HH:mm:ss",
    );
    //  ===sec2======
    detailsheet.getCell("B11").value = res.data?.user_submission;
    detailsheet.getCell("B12").value = res.data?.user_model;
    detailsheet.getCell("B13").value = res.data?.all_submission;
    detailsheet.getCell("B14").value = res.data?.most_userSubmission;
    detailsheet.getCell("B15").value = res.data?.avg_submission;
    detailsheet.getCell("B16").value = res.data?.most_teamSubmission;
    detailsheet.getCell("B17").value = res.data?.dataset_dowload;

    // =============sheet performance================
    const worksheet = workbook.addWorksheet("PerformancePublic");
    const worksheet2 = workbook.addWorksheet("PerformancePrivate");
    const worksheet3 = workbook.addWorksheet("PerformancePublicDuplicateTeam");
    const worksheet4 = workbook.addWorksheet("PerformancePrivateDuplicateTeam");
    const respublic = handleReindex(res_performance.data[0].public);
    const resprivate = handleReindex(res_performance.data[0].private);
    const respublic_dup = handleReindex(res_performance.data[0].public_dup);
    const resprivate_dup = handleReindex(res_performance.data[0].private_dup);
    handleCreatSheet(
      worksheet,
      respublic,
      res_performance.data[0].metrics_public,
    );
    handleCreatSheet(
      worksheet2,
      resprivate,
      res_performance.data[0].metrics_private,
    );
    handleCreatSheet(
      worksheet3,
      respublic_dup,
      res_performance.data[0].metrics_public,
    );
    handleCreatSheet(
      worksheet4,
      resprivate_dup,
      res_performance.data[0].metrics_private,
    );

    // ===============================================================

    // บันทึกไฟล์ Excel
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buffer]),
      `leader_${new Date().toISOString().slice(0, 10)}.xlsx`,
    );
  };

  const handleCreatSheet = (worksheet, Performance, metric) => {
    try {
      // Merge Column ด้านบน
      worksheet.mergeCells("A1:A2"); // รวมเซลล์ F1 และ G1
      worksheet.mergeCells("B1:B2"); // รวมเซลล์ F1 และ G1
      worksheet.mergeCells("C1:C2"); // รวมเซลล์ F1 และ G1
      worksheet.mergeCells("D1:D2"); // รวมเซลล์ F1 และ G1
      worksheet.mergeCells("E1:E2"); // รวมเซลล์ F1 และ G1
      worksheet.mergeCells("F1:F2"); // รวมเซลล์ F1 และ G1
      worksheet.mergeCells("G1:G2"); // รวมเซลล์ F1 และ G1

      // =========
      worksheet.getCell("A1").value = "อันดับ";
      worksheet.getCell("B1").value = "ชื่อผู้ใช้";
      worksheet.getCell("C1").value = "ชื่อทีมผู้ใช้งาน";
      worksheet.getCell("D1").value = "จำนวน submit";
      worksheet.getCell("E1").value = "ชื่อโมเดล";
      worksheet.getCell("F1").value = "ขนาดโมเดล";
      worksheet.getCell("G1").value = "เวลา inference";

      worksheet.getCell("H1").value = "Matric ต่างๆ ตามที่ระบุใน Task";
      worksheet.getCell("H1").alignment = {
        horizontal: "center",
        vertical: "middle",
      }; // จัดตำแหน่งข้อความ
      worksheet.getCell("H1").font = { bold: true }; // ทำให้ตัวอักษรหนาฃ
      worksheet.getCell("H1").fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "A6C9EC" }, // สีเหลืองทอง
      };

      // ตั้งค่า background color และจัดตำแหน่งข้อความสำหรับเซลล์หัวคอลัมน์
      const headerCells = ["A1", "B1", "C1", "D1", "E1", "F1", "G1"];
      headerCells.forEach((cell) => {
        worksheet.getCell(cell).alignment = {
          horizontal: "center",
          vertical: "middle",
        };
        worksheet.getCell(cell).font = { bold: true };
        worksheet.getCell(cell).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "DAE9F8" }, // สีเหลืองทอง
        };
      });

      const widthColumns = [
        { width: 10 }, // อันดับ
        { width: 15 }, // ชื่อผู้ใช้
        { width: 15 }, // ชื่อทีม
        { width: 15 }, // จำนวน submit
        { width: 20 }, // ชื่อโมเดล
        { width: 15 }, // ขนาดโมเดล
        { width: 25 }, // เวลา inference
      ];

      const metrics = Object.keys(metric);
      console.log("metric:", metrics);
      if (metrics.length != 0) {
        worksheet.mergeCells(`H1:${String.fromCharCode(71 + metrics.length)}1`);
        metrics.forEach((metric, index) => {
          const columnLetter = String.fromCharCode(72 + index); // 71 = ASCII 'G'
          worksheet.getCell(`${columnLetter}2`).value = metric;
          worksheet.getCell(`${columnLetter}2`).alignment = {
            horizontal: "center",
            vertical: "middle",
          }; // จัดตำแหน่งข้อความ
          worksheet.getCell(`${columnLetter}2`).font = { bold: true }; // ทำให้ตัวอักษรหนา
          widthColumns.push({ width: 20 });
        });
      }

      // data.forEach(row => {
      Performance.forEach((row) => {
        worksheet.addRow(row);
      });

      // จัดฟอร์แมต: ทำให้หัวตาราง (แถวที่ 2) เป็นตัวหนา
      worksheet.getRow(2).font = { bold: true };

      // กำหนดความกว้างของคอลัมน์
      worksheet.columns = widthColumns;
    } catch (e) {
      console.error(e);
    }
  };

  const handleReindex = (data) => {
    try {
      return data
        .map((item, index) => ({ ...item, id: index + 1 }))
        .map((item) => Object.values(item));
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div>
      <Button
        style={{ background: "green", color: "white" }}
        onClick={exportExcel}
      >
        Export
      </Button>
    </div>
  );
};

export default ExportExcel;
